var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"main"},[_c('banner'),_c('placa'),_c('promo'),_c('about'),_c('distributor'),_c('features'),_c('download'),_c('automatic'),_c('comunication'),_c('fluxo'),_c('TrialTest'),_c('pricing'),_c('site-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }